import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { Constants } from 'utilities/constants';

const longerLabelWidth = 130

const underwriteStatuses = {
  [Constants.UnderwriteStatus.SAVEDNOBID]: {
    text: 'Saved No Bid',
    // color: '#BE1E2D' // Red
    backgroundColor: '#dc5151' // Red
  },
  [Constants.UnderwriteStatus.SAVEDPRICING]: {
    text: 'Saved Pricing',
    // color: '#F79868' // Orange
    backgroundColor: '#faa307', // Orange
  },
  [Constants.UnderwriteStatus.SUBMISSIONPENDING]: {
    text: 'Submission Pending',
    width: longerLabelWidth + 10,
    // color: '#10565D' // Green
    backgroundColor: '#3AC78A', // Light(ish) green
  },
  [Constants.UnderwriteStatus.SUBMISSIONFAILED]: {
    text: 'Submission Failed',
    width: longerLabelWidth,
    // color: '#10565D' // Green
    backgroundColor: '#EA9696', // Light(ish) red
  },
  [Constants.UnderwriteStatus.SUBMITTEDNOBID]: {
    text: 'Submitted No Bid',
    // color: '#BE1E2D' // Red
    backgroundColor: '#dc5151' // Red
  },
  [Constants.UnderwriteStatus.SUBMITTEDPRICING]: {
    text: 'Submitted Pricing',
    // color: '#10565D' // Green
    backgroundColor: '#67c12e', // Bright green
  },
  [Constants.UnderwriteStatus.AUTOPRICED]: {
    text: 'Autopriced',
    backgroundColor: '#FFF',
    border: '1px solid #000',
    color: '#000'
  },
  [Constants.UnderwriteStatus.PENDING]: {
    text: 'Pending',
    // color: '#E4C5AF' // Dark yellow
    backgroundColor: '#E4C5AF', // Dark yellow
  },
};

export const getChipStatus = (underwriteStatus) => {
  const foundStatus = underwriteStatuses[underwriteStatus];
  if (!foundStatus) {
    console.log(`UnderwriteStatusChip.js - underwriteStatus of ${underwriteStatus} not recognized`);
    return null;
  }
  return {
    backgroundColor: foundStatus.backgroundColor,
    text: foundStatus.text,
    border: foundStatus.border,
    color: foundStatus.color,
    width: foundStatus.width
  }
}

const UnderwriteStatusChip = ({ classes, style, underwriteStatus }) => {
  if (!underwriteStatus) return null;
  const myStatus = getChipStatus(underwriteStatus);
  if (!myStatus) {
    return null;
  }

  return <Chip
    classes={{
      root: classes.compTypeChip,
      label: classes.label
    }}
    style={{ backgroundColor: myStatus.backgroundColor, color: myStatus.color, border: myStatus.border, width: myStatus.width ?? 111, ...style }}
    label={myStatus.text}
  />
}

const styles = theme => ({
  compTypeChip: {
    height: 18,
    color: '#fff'
  },
  label: {
    overflow: 'initial'
  }
});

export default withStyles(styles)(UnderwriteStatusChip);